// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__3e3fG","header":"Messages_header__2ux_f"};